import { render } from "./TestimonialContent.vue?vue&type=template&id=51656b26"
import script from "./TestimonialContent.vue?vue&type=script&lang=js"
export * from "./TestimonialContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__